import { useCallback, useSyncExternalStore } from "react";

export class LocalStorageService {
  static Keys = {
    HAS_AUTHENTICATED_ONCE: "hasAuthenticatedOnce",
    AUTH_OVERRIDE: "authOverride", // { token: string; url: string }
  };

  static getItem(key: string) {
    return localStorage.getItem(key);
  }

  static setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }
}

const subscribeToLocalStorage = (callback: () => void) => {
  window.addEventListener("storage", callback);
  return () => window.removeEventListener("storage", callback);
};

// Hook to follow the value of a local storage key
export const useLocalStorage = (key: string) => {
  const getSnapshot = useCallback(
    () => LocalStorageService.getItem(key),
    [key],
  );

  return useSyncExternalStore(subscribeToLocalStorage, getSnapshot);
};

// Hook to follow the value of a local storage key, parsing it as JSON
export const useLocalStorageJSON = (key: string) => {
  const value = useLocalStorage(key);
  return value ? JSON.parse(value) : undefined;
};
